import {
  AfterContentInit,
  Component,
  ContentChildren, ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  QueryList, SimpleChanges,
  TemplateRef,
  ViewChild
} from '@angular/core';
import {StandardFormMetaInfo} from '../standard-form-builder/standard-form-meta-info.model';
import {LocaleService} from '../../../../shared/services/locale.service';
import {extractValue} from '../standard-form-builder/standard-form.helpers';
import {DomSanitizer} from '@angular/platform-browser';
import {InsparkMessageService, InsparkTemplate} from '@inspark/inspark-components';
import {copy2clipboard} from '../../../../shared/functions/copy2clipboard';
import { TranslateService } from '@ngx-translate/core';
import {HttpClient} from '@angular/common/http';
import _ from 'lodash';

@Component({
  selector: 'app-ruleaction-form-builder',
  templateUrl: './ruleaction-form-builder.component.html',
  styleUrls: ['./ruleaction-form-builder.component.scss']
})
export class RuleactionFormBuilderComponent implements OnInit, AfterContentInit, OnChanges, OnDestroy {
  @Input() section: any = {};
  @Input() ruleaction: any = {};
  @Input() ruleactions: any[] = [];
  // @Input() selactions: any[];
  @Input() typicalconfigId: number;
  @Input() isCondition  = false;
  @ViewChild('in', { static: false }) inputEL: ElementRef;


  @Input() isOneColumn = false;
  @Input() meta: StandardFormMetaInfo[];
  @Input() values: any;
  @Input() itemOptions: any = {};
  @Input() buttons;
  @Input() buttonsLabels: { save?: string; create?: string; copy?: string; delete?: string; savetitle?: string; operatingmode?: string; timeschedule?: string; upload?: string } =
    {save: 'SAVE', create: 'CREATE', copy: 'COPY', delete: 'DELETE', operatingmode: 'OPERATINGMODE', timeschedule: 'TIMESCHEDULE', upload: 'UPLOAD'};
  @Input() inAction = false;
  @Input() testEntryPointSelector = 'form_builder';
  @Input() disabled = {save: false, create: false, copy: false};
  @Input() inTemplates: QueryList<InsparkTemplate>;
  @Output() save = new EventEmitter<any>();
  @Output() root = new EventEmitter<any>();
  @Output() create = new EventEmitter<any>();
  @Output() createCondition = new EventEmitter<any>();
  @Output() delete = new EventEmitter<any>();
  @ContentChildren(InsparkTemplate) templates: QueryList<InsparkTemplate>;
  public sectionsState: any = {};
  private isChanged = false;
  protected hasNotSavedParameter = false;
  protected hasNotSavedValue = false;
  protected hasNotSavedRoot = false;
  filteredDeviceparamsSingle: any[];
  //selectedDeviceparam: any = {label: 'Select deviceparam', value: null};
  filteredSelDeviceparams: any[] = [];


  filteredRuleActionsSingle: any[];
  selectedRuleAction: any = {label: 'Select ruleaction', value: null};
  filteredSelActions: any[] = [];

  checkDdlFlag = false;
  checkDdlFlag2 = false;

  emptyOption = {
    label: null,
    value: null
  };
  // tslint:disable-next-line:max-line-length
  public readonly svgInfo = '<?xml version="1.0" encoding="UTF-8"?><!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="24" height="24" viewBox="0 0 24 24"><path d="M11,9H13V7H11M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M11,17H13V11H11V17Z" /></svg>';

  public svg;

  readonly DEFAULT_MAX_LENGTH = 65535;
  bodyTemplate: TemplateRef<any>;
  valueTemplate: TemplateRef<any>;
  calendarLocale;
  localesub;
  isValidPattern = true;
  enterPress = false;
  isFastProccession = true;

  constructor(
    private localeService: LocaleService,
    private sanitizer: DomSanitizer,
    private translateService: TranslateService,
    private http: HttpClient,
    private messageService: InsparkMessageService
  ) {

  }

  ngOnInit() {
    this.svg = this.sanitizer.bypassSecurityTrustHtml(this.svgInfo);

    if (this.itemOptions?.deviceparams && this.itemOptions?.deviceparams.length < 500) {
      this.isFastProccession = true;
      this.filteredSelDeviceparams = _.cloneDeep(this.itemOptions.deviceparams);
      this.filteredSelActions = _.cloneDeep(this.itemOptions.deviceparams);
    } else {
      this.isFastProccession = false;
    }
  }

  ngOnDestroy() {
    if (this.localesub) {
      this.localesub.unsubscribe();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.ruleaction && this.ruleaction.deviceparam && !this.ruleaction.deviceparam.value) {
      this.ruleaction.deviceparam = {label: this.ruleaction.deviceparam.paramname, value: this.ruleaction.deviceparam};
    }
    for (let propName in changes) {
      if(propName === 'ruleaction'){
        if (this.ruleaction && this.ruleaction.action && !this.ruleaction.action.label) {
          this.ruleaction.action = {label: this.ruleaction.action, value: null};
        }
      }
    }
  }


  /**
   * Транcформирует значение поля в null, если ничего не выбрано для in-dropdown.
   *
   * @param val - текущее значение in-dropdown из $event
   * @param fieldName - названия поля в объекте value
   */
  transformEmpty(val, fieldName) {
    if ( val.isEmpty ) {
      this.values[fieldName] = null;
    }
  }

  compareById(a, b) {
    if (a === null || b === null) {
      return false;
    }
    if (a && b && (a.id === undefined || b.id === undefined)) {
      return a && b && a === b;
    }
    return a && b && a.id === b.id;
  }

  compareByValue(a, b) {
    return a && b && a === b;
  }

  getCompositeValue(value, field) {
    field.forEach(key => value = value[key]);
    return value;
  }

  filterItems(itemInfo) {
    const from = itemInfo.filter.fromField;
    const to = itemInfo.filter.toField;
    const category = itemInfo.filter.categoryField;

    const getIdByKey = (values, key, defaultValue = -1) => {
      if (!values[key] || !values[key].id) {
        return defaultValue;
      }
      return values[key].id;
    };
    const filterObj = (this.itemOptions[itemInfo.filter.options] || []).find(_v => +_v.id === +getIdByKey(this.values, itemInfo.filter.key));

    const items = this.itemOptions[itemInfo.item.options];

    if (filterObj) {
      const filtered = items.filter(
        _item =>
          +extractValue(_item, from, -1) === +extractValue(filterObj, to, -2));
      const categories = {};
      filtered.forEach(_fitem => {
        const categoryName = extractValue(_fitem, category, '');
        categories[categoryName] = categories[categoryName] || [];
        categories[categoryName].push(_fitem);
      });
      return categories;
    }
    return {};
  }

  getValue(values, info) {
    let result = '';
    try {
      result = info.value(values);
    } catch (e) {
      result = '';
    }

    return result;
  }

  ngAfterContentInit() {
    if (this.inTemplates) {
      this.inTemplates.forEach((item) => {
        switch (item.getType()) {
          case 'body':
            this.bodyTemplate = item.template;
            break;
          case 'value':
            this.valueTemplate = item.template;
            break;

        }
      });
    }

    this.templates.forEach((item) => {
      switch (item.getType()) {
        case 'body':
          this.bodyTemplate = item.template;
          break;
        case 'value':
          this.valueTemplate = item.template;
          break;

      }
    });

  }

  closeTooltip(tooltip): void {
    tooltip.close();
  }

  copy2clipboard($event, field) {
    copy2clipboard(this.values[field] + '');
  }

  textInput = _.debounce((flag, p) => {
    this.changeFilter(flag, p);
  }, 1000);

  changeFilter(flag, p) {
    if (!this.ruleaction || !this.ruleaction.deviceparam) {
      this.ruleaction.deviceparam = {label: null, value: null};
    }
    if (flag === 0) {
      const dsp = this.ruleaction?.deviceparam.label ? this.ruleaction.deviceparam.label : this.ruleaction?.deviceparam;
      const name =p ? '&name=*' +  encodeURIComponent(dsp) + '*' : '';
      const host = `/db/deviceparam/shortest?configId=${this.typicalconfigId}${name}`;
      this.http.get(host).subscribe(data => {
        this.filteredSelDeviceparams = (data as any[]);
        this.filteredDeviceparamsSingle = this.filterParam(this.ruleaction?.deviceparam, this.filteredSelDeviceparams);
        //this.selectedDeviceparam = this.filteredDeviceparamsSingle.length === 0 ? this.ruleaction?.deviceparam : this.filteredDeviceparamsSingle[0];
      }, error => {
        if (error.error?.Message) {
          this.messageService.error(error.error.Message);
        } else {
          this.messageService.error('Ошибка при обращении к серверу');
        }
      });
    } else if (flag === 1) {
      const name = p ? '&name=*' + encodeURIComponent(this.ruleaction?.action) + '*' : '';
      const host = `/db/deviceparam/shortest?configId=${this.typicalconfigId}${name}`;
      this.http.get(host).subscribe(data => {
        this.filteredSelActions = (data as any[]);
        this.filteredRuleActionsSingle = this.filterParam(this.ruleaction?.action, this.filteredSelActions);
        this.selectedRuleAction = this.filteredRuleActionsSingle.length === 0 ? this.ruleaction?.action : this.filteredRuleActionsSingle[0];
      }, error => {
        if (error.error?.Message) {
          this.messageService.error(error.error.Message);
        } else {
          this.messageService.error('Ошибка при обращении к серверу');
        }
      });
    }
  }

  onKeyUp(event, flag) {
    if (event.keyCode === 17) {
      return;
    }
    if (event.keyCode === 40 || event.keyCode === 38 || event.keyCode === 39 || event.keyCode === 37) {
      return;
    }
    const dsp = (this.ruleaction.deviceparam?.label || this.ruleaction.deviceparam?.label === null) ? this.ruleaction.deviceparam.label : this.ruleaction.deviceparam;
    const act = (this.ruleaction.action || this.ruleaction.action === null) ? this.ruleaction.action : '';
    if (flag === 0) {
      this.checkDdlFlag = false;
    } else if (flag === 1) {
      this.checkDdlFlag2 = false;
    }


    if (event.keyCode === 13) {
      if ((flag === 0 && (!dsp || dsp == '')) || (flag === 1 && (!act || act == ''))) {
        this.textInput(flag, false);
      } else if ((flag === 0 && !(dsp && dsp.length > 2)) || (flag === 1 && !(act && act.length > 2))) {
        this.textInput(flag, true);
      }

    } else if ((flag === 0 && dsp && dsp.length >= 3) ||  (flag === 1 && act && act.length >= 3)){
      this.textInput(flag, true);
    }
  }
  filterDeviceparamSingle(event) {
    const s = this.inputEL;
    const query = event.query;
    this.filteredDeviceparamsSingle = this.filterParam(query, this.filteredSelDeviceparams);
    //this.selectedDeviceparam = this.filteredDeviceparamsSingle.length === 0 ? query : this.filteredDeviceparamsSingle[0];

  }

  filterRuleActionSingle(event) {
    const s = this.inputEL;
    this.filteredRuleActionsSingle = this.filterParam(this.ruleaction?.action, this.filteredSelActions);
    this.selectedRuleAction = this.filteredRuleActionsSingle.length === 0 ? this.ruleaction?.action : this.filteredRuleActionsSingle[0];
  }

  filterParam(query, params: any[]): any[] {
    const filtered: any[] = [];
    for (let i = 0; i < params.length; i++) {
      const param = params[i];
      if (param && query && param.paramname && param.paramname.toLowerCase().indexOf((query + '').toLowerCase()) !== -1) {
        filtered.push({label: param.paramname, value: param});
      } else if (!query && param && param.paramname) {
        filtered.push({label: param.paramname, value: param});
      } else if (query.length === 0) {
        filtered.push({label: param.paramname, value: param});
      }
    }
    return filtered;
  }



  checkDdl(event, flag) {
    if (!this.checkDdlFlag) {
      this.checkDdlFlag = true;
      const dsp = (this.ruleaction.deviceparam?.label || this.ruleaction.deviceparam?.label === null) ? this.ruleaction.deviceparam.label : this.ruleaction.deviceparam;
      if ((flag === 0 && (!dsp || dsp == ''))) {
        this.textInput(flag, false);
      } else if ((flag === 0 && !(dsp && dsp.length > 2))) {
        this.textInput(flag, true);
      }
    }
  }

  checkDdl2(event, flag) {
    if (!this.checkDdlFlag2) {
      this.checkDdlFlag2 = true;
      const act = (this.ruleaction.action || this.ruleaction.action === null) ? this.ruleaction.action : '';
      if (flag === 1 && (!act || act == '')) {
        this.textInput(flag, false);
      } else if (flag === 1 && !(act && act.length > 2)) {
        this.textInput(flag, true);
      }
    }
  }

  switchRuleActionRootable(event) {
    //event.root = !event.root;
    this.root.emit(event);
  }

  saveAction(ruleaction) {
    this.save.emit(ruleaction);
  }

  deleteAction(ruleaction) {
    this.delete.emit(ruleaction);
  }

  plusAction(ruleaction) {
    this.create.emit(ruleaction);
  }

  plusCondition(ruleaction) {
    this.createCondition.emit(ruleaction);
  }

  getTitle(str) {
    if (str && str.length > 50) {return str;}
    return null;
  }

  isSaveAvailable() {
    const dsp = this.ruleaction.deviceparam?.label ? this.ruleaction.deviceparam.label : this.ruleaction.deviceparam;
    const act = this.ruleaction.action ? this.ruleaction.action : '';
    if (dsp && dsp.length > 1) {
      this.hasNotSavedValue = false;
    } else {
      this.hasNotSavedValue = true;
    }
    if (act && act.length > 1) {
      this.hasNotSavedParameter = false;
    } else {
      this.hasNotSavedParameter = true;
    }

  }

}
